import agixNetworks from 'singularitynet-token-contracts/networks/SingularityNetToken.json';
import sdaoFarmingNetworks from 'singularitydao-farming-contracts/networks/SDAOTokenStaking.json';
import sdaoFarmingNetworksV2 from '@singularitydao/v1-farming-contracts/networks/SDAOTokenStaking.json';
import sdaoBondedTokenStakeNetworks from '@singularitydao/v1-farming-contracts/networks/SDAOBondedTokenStake.json';
import sdaoTokenNetworks from 'singularitydao-token-contracts/networks/SDAOToken.json';
import { freeze } from '../../utils/object';
import { bsc, goerli, hardhat, mainnet, base } from 'wagmi/chains';

const ropstenAddresses = freeze({
  UNBONDED_STAKING_V2_NTX: '0x924c4CfcF84fD87C7045E490b16E21A3014c04D7',
  BONDED_STAKING_2: '0xb54336CBE6f74c224185412f43A56DD5Dc01b1b4',
  BONDED_STAKING_NTX: '0xc1a498e2536618390f6b4f9dc867f9be1b9d8a32',
  NTX: '0x7f44bc93bcb96011800da80d1a31e05e5a5ac7f9',
  USDT: '0x110a13FC3efE6A245B50102D2d79B3E76125Ae83',
  ROUTER_V2: '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D',
  LP_TOKEN_SDAO: '0x4c78b6566864ae6304c2c2a4c43b74dafaac167e',
  LP_TOKEN_AGIX: '0x5318855ad173220e446002c01d5ee5f940502e70',
  LP_TOKEN_SDAO_USDT: '0x98C4494dA35D52C5cc5f538df32fA0fdB5FCc51D',
  LP_TOKEN_AGIX_USDT: '0x10Eff2Eed050a97d23df826BC226c123e030ac07',
  LP_TOKEN_NTX: '0xd21e63d34371ca6a6c67f76019b0a04acfadcc64',
  LP_TOKEN_SDAO_V1: '0x4c78b6566864ae6304c2c2a4c43b74dafaac167e',
  LP_TOKEN_AGIX_V1: '0x5318855ad173220e446002c01d5ee5f940502e70',
  LP_TOKEN_SDAO_USDT_V1: '0x98C4494dA35D52C5cc5f538df32fA0fdB5FCc51D',
  LP_TOKEN_AGIX_USDT_V1: '0x10Eff2Eed050a97d23df826BC226c123e030ac07',
  WETH: '0xc778417e063141139fce010982780140aa0cd5ab',
});

const mainnetAddresses = freeze({
  UNBONDED_STAKING_V2: sdaoFarmingNetworksV2[mainnet.id].address,
  UNBONDED_STAKING_V2_NTX: '0xb267DeaACe0B8c5FcB2bb04801A364e7Af7DA3F4',
  BONDED_STAKING: sdaoBondedTokenStakeNetworks[mainnet.id].address,
  BONDED_STAKING_2: '0xF5738B4aD2f8302b926676692a0C09603d930b42',
  BONDED_STAKING_NTX: '0x502b965d3d51d4fd531e6a1c1fa9bfa50337ba55',
  FARMING_REWARD: sdaoFarmingNetworks[mainnet.id].address,
  SDAO: sdaoTokenNetworks[mainnet.id].address,
  NTX: '0xf0d33beda4d734c72684b5f9abbebf715d0a7935',
  AGIX: agixNetworks[mainnet.id].address,
  UNBONDED_STAKING_RJV: '0x5caDCF74A14a6aa67e95E418625b82831b241b58',
  UNBONDED_STAKING_RJVOLD: '0x655E370104Ad4E4EE091b588aEc8A24156601Ca1',
  UNBONDED_STAKING_HYPC: '0xd1061Ff97c34835B90E3f8080e3AE2e5C8B38f1D',
  UNBONDED_STAKING_SOPH: '0xCe99861F0244D6478a309e2c2565FDaaAA8b0bFb',
  UNBONDED_STAKING_CGV: '0x31Cd039D37DEe0C989cbE390F668fc38b033fB4f',
  UNBONDED_STAKING_SKYA: '0x7Cc63D9D3Db18d4244c2F0eFd0Ca6fed605d83Fe',
  RJV: '0xa1f410f13B6007fCa76833ee7eb58478D47Bc5Ef',
  RJVOLD: '0x02c3296C6eb50249f290AE596F2bE9454bFfadaB',
  HYPC: '0xeA7B7DC089c9a4A916B5a7a37617f59fD54e37E4',
  SOPH: '0x73fBD93bFDa83B111DdC092aa3a4ca77fD30d380',
  CGV: '0xaeF420fd77477d9Dc8B46D704D44dD09d6c27866',
  SKYA: '0x623cD3a3EdF080057892aaF8D773Bbb7A5C9b6e9',
  USDT: '0xdac17f958d2ee523a2206206994597c13d831ec7',
  USDC: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
  ROUTER_V2: '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D',
  LP_TOKEN_SDAO: '0x424485f89ea52839fdb30640eb7dd7e0078e12fb',
  LP_TOKEN_CGV: '0xEDeE549ae9d53B67FA23C364a1D75B8Ee7c2527d',
  LP_TOKEN_AGIX: '0xe45b4a84e0ad24b8617a489d743c52b84b7acebe',
  LP_TOKEN_SDAO_USDT: '0x3a925503970d40d36d2329e3846e09fcfc9b6acb',
  LP_TOKEN_AGIX_USDT: '0x4bb0925fa50da9b4c8936869433b48e78ccc5c13',
  LP_TOKEN_DYNBTC: '0xff46d5837f9b7ae71fcc32b4e28ec96d2e39c826',
  LP_TOKEN_DYNETH: '0x144a31d53e3ab88de786455a4f56c1b8f5c5e1f8',
  LP_TOKEN_NTX: '0xb3d994978d2bc50d2ce74c45fcd923e7c9c06730',
  LP_TOKENS_RJV: '0xff70dE5183Aede4be2EFf73EFcC8EA2A8590229B',
  LP_TOKENS_RJVOLD: '0x30e3270FD3d1589672e8da2F15c7076323C9Aa10',
  LP_TOKEN_HYPC: '0xcc0FCd959871E69F84fe9464C629f327941b655B',
  LP_TOKEN_SOPH: '0x9DD361cf608BcAcdc21effD2273c60AfE2dF3637',

  LP_TOKEN_SDAO_V1: '0x424485f89ea52839fdb30640eb7dd7e0078e12fb',
  LP_TOKEN_AGIX_V1: '0xe45b4a84e0ad24b8617a489d743c52b84b7acebe',
  LP_TOKEN_SDAO_USDT_V1: '0x3a925503970d40d36d2329e3846e09fcfc9b6acb',
  LP_TOKEN_AGIX_USDT_V1: '0x4bb0925fa50da9b4c8936869433b48e78ccc5c13',

  WETH: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
  DYNBTC: '0xDa49AF8773Cb162ca56f8431442c750896F8C87A',
  DYNETH: '0x7bb1A6b19e37028B3aA5c580339c640720E35203',
});

export const bscAddresses = freeze({
  SDAO: '0x90Ed8F1dc86388f14b64ba8fb4bbd23099f18240',
  WBNB: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
  BUSD: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
  NTX: '0x5C4Bcc4DbaEAbc7659f6435bCE4E659314ebad87',
  USDC: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
  ROUTER_V2: '0x10ED43C718714eb63d5aA57B78B54704E256024E',
  LP_TOKEN_SDAO_WBNB: '0x43b95976cf0929478bc13332c9cd2d63bf060976',
  LP_TOKEN_SDAO_BUSD: '0x3d12e4381901a6b94438758b90881cb03f10b01e',
  LP_TOKEN_NTX_WBNB: '0x6c805d2077025eaaa42fae7f764e61df42aadb14',
  LP_TOKEN_RJV_WBNB: '0x1a229191fd995A5C95694Ee78AB5d3C8c8793023',
  LP_TOKEN_RJVOLD_WBNB: '0x03aFA7e78621d2F5d1b4c8Bb1bB813CE87E95925',
  LP_TOKEN_HYPC_WBNB: '0xBC5092A8e2174fE8931847C48C4158Ef73713266',
  LP_TOKEN_CGV_WBNB: '0xFd22bc3F3b467F72B87146Ef87863C7766789c51',
  LP_TOKEN_SOPH_WBNB: '0x79083C25B5408b4e87855f9efA266cF370B2bD05',

  RJVOLD: '0x1135883a1bC6776bF90c97845adc491922106dFb',
  RJV: '0x602B6C6ccE5F95c00603bd07D8fA7EbAF3747D44',
  HYPC: '0x7881cD2B5724431372F57C50E91611352557A606',
  CGV: '0x1bDaF9ddD7658d8049391971d1fd48c0484F66EC',
  SOPH: '0x73fBD93bFDa83B111DdC092aa3a4ca77fD30d380',
  UNBONDED_STAKING: '0x79292c62F593E08d9b850b790b07E7a0903fD007',
  UNBONDED_STAKING_NTX: '0xBa1933bc47e6Ad050A4E4485F6f4b16b9CcdB806',
  BONDED_STAKING: '0x17de46760F4c18C26eEc36117C23793299F564A8',
  UNBONDED_STAKING_RJVOLD: '0x93192A62008E25c33CBC3e60A00D27736b7b423F',
  UNBONDED_STAKING_RJV: '0x738A23A889a6257Ea8678803e4b8Db9605D63B9C',
  UNBONDED_STAKING_HYPC: '0x158a1d0144D8e5449305435DFaDEe07cd2dC85F4',
  UNBONDED_STAKING_CGV: '0xB9892Aed8E49bf167Eb15D269777F6F5850aE450',
  UNBONDED_STAKING_SOPH: '0xD8912300C2b96d9F2fb8f4a9cFea351Ebe2A696E',
});

const baseAddresses = freeze({
  SKYA: '0x623cD3a3EdF080057892aaF8D773Bbb7A5C9b6e9',
  SOPH: '0x73fBD93bFDa83B111DdC092aa3a4ca77fD30d380',
  UNBONDED_STAKING_SKYA: '0x8a7f47da04911307C0AbA48E48BC4E3165bA976f',
  UNBONDED_STAKING_SOPH: '0xfB85B9Ec50560e302Ab106F1E2857d95132120D0',
});

export const ContractAddress = freeze({
  [mainnet.id]: mainnetAddresses,
  [goerli.id]: ropstenAddresses,
  [bsc.id]: bscAddresses,
  [hardhat.id]: mainnetAddresses,
  [base.id]: baseAddresses,
});

export const SFITokenAddress = freeze({
  [mainnet.id]: {
    title: 'Ethereum',
    address: '0x7636D8722Fdf7cd34232a915E48e96aA3eB386BF',
    url: 'https://etherscan.io/token/0x7636D8722Fdf7cd34232a915E48e96aA3eB386BF',
  },
  [base.id]: {
    title: 'Base',
    address: '0x863B7364a29daA23C9FCBD02e27D129A8B185891',
    url: 'https://basescan.org/token/0x863B7364a29daA23C9FCBD02e27D129A8B185891',
  },
  [bsc.id]: {
    title: 'BNB Smart Chain',
    address: '0x7636D8722Fdf7cd34232a915E48e96aA3eB386BF',
    url: 'https://bscscan.com/token/0x7636D8722Fdf7cd34232a915E48e96aA3eB386BF',
  },
});
